<template>
    <div style="width:100%;height: 100%;float: left;" :style="{ backgroundColor: btn.backgroundColor, opacity: btn.opacity, borderRadius: btn.borderRadius+'px' }">
    </div>
</template>

<script>

export default {
    props: ['btn']
}    
</script>